import { Link } from 'react-router-dom';
import type { PermissionCode } from '@oxxean/types';
import { Card } from './primitives';
import { Icon } from './Icon';

export function ForbiddenNotice({ permission }: { permission?: PermissionCode }): JSX.Element {
  return (
    <div className="page">
      <Card>
        <div className="state" role="alert">
          <span className="state__icon state__icon--error">
            <Icon name="shield" size={19} />
          </span>
          <span className="state__title">No tiene acceso a esta sección</span>
          <span className="state__msg">
            Su perfil no incluye el permiso necesario para ver este módulo. Si cree que debería
            tenerlo, solicítelo a la Gerencia de Personas indicando el módulo al que necesita acceder.
          </span>
          {permission !== undefined && (
            <span className="mono muted">Permiso requerido: {permission}</span>
          )}
          <Link className="btn" to="/">
            Volver al inicio
          </Link>
        </div>
      </Card>
    </div>
  );
}
